import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import WelcomeHero from './components/WelcomeHero';
import Button from '../../components/ui/Button';

const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handlePrivacyPolicy = () => {
    alert('Privacy Policy: This is a demo application. No real data is collected or stored.');
  };

  const handleTermsOfService = () => {
    alert('Terms of Service: This is a demo application for portfolio tracking purposes.');
  };

  const handleSupport = () => {
    alert('Support: For demo purposes, use credentials: demo@stocktracker.com / StockTracker2025!');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container-financial py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left Column - Welcome Content */}
          <div className="order-2 lg:order-1">
            <WelcomeHero />
            
            {/* Trust Signals - Hidden on mobile, shown on desktop */}
            <div className="hidden lg:block mt-12">
              <TrustSignals />
            </div>
          </div>

          {/* Right Column - Login Form */}
          <div className="order-1 lg:order-2">
            <div className="sticky top-24">
              <LoginForm />
              
              {/* Mobile Trust Signals */}
              <div className="lg:hidden mt-8">
                <TrustSignals />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section - Additional Info */}
        <div className="mt-16 border-t border-border pt-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Real-Time Data
              </h3>
              <p className="text-sm text-muted-foreground">
                Get live market updates and portfolio performance tracking 
                with millisecond precision.
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Advanced Analytics
              </h3>
              <p className="text-sm text-muted-foreground">
                Comprehensive charts, trends, and insights to make 
                informed investment decisions.
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Secure & Reliable
              </h3>
              <p className="text-sm text-muted-foreground">
                Bank-level security with 99.9% uptime guarantee 
                for your peace of mind.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="mt-16 border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} StockTracker Pro. All rights reserved.
            </div>
            
            <div className="flex space-x-6">
              <Button
                variant="ghost"
                size="sm"
                onClick={handlePrivacyPolicy}
                className="text-sm text-muted-foreground hover:text-foreground"
              >
                Privacy Policy
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleTermsOfService}
                className="text-sm text-muted-foreground hover:text-foreground"
              >
                Terms of Service
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleSupport}
                className="text-sm text-muted-foreground hover:text-foreground"
              >
                Support
              </Button>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default LoginPage;